import { apiProxyRequest } from "Api/apiProxyRequest";

import { getDeploymentNextUrl } from "./utils";

import type { Deployment, DeploymentUpdateParams } from "./types";
import type { Activity } from "Api/activity/types";

type UpdateDeploymentNextRequestProps = {
  projectId: string;
  environmentId: string;
  deploymentData: Partial<DeploymentUpdateParams>;
};

export const updateDeploymentNextRequest = ({
  projectId,
  environmentId,
  deploymentData
}: UpdateDeploymentNextRequestProps) => {
  return apiProxyRequest<{
    code: number;
    location: string;
    status: string;
    _embedded: {
      entity: Deployment;
      activities: Activity[];
    };
  }>(
    getDeploymentNextUrl({ projectId, environmentId }),
    "PATCH",
    deploymentData
  );
};
